var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"aSzeLvnG9hNjgZW5G2wVX"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

// FIXME: This is a temporary solution to ignore the enforce-module-boundaries rule that prevents circular dependencies
// eslint-disable-next-line @nx/enforce-module-boundaries
import { default as baseConfig } from '../../config/sentry.config';

Sentry.init({
  ...baseConfig,
});
